import React from "react";

type Props = {
  children: React.ReactNode;
  /** Tone for placement on light (default) vs dark image backgrounds */
  tone?: "teal" | "lime";
  className?: string;
};

/**
 * DM Mono uppercase label used above section headings
 * (e.g. "02 — THE COLLECTION", "WE'RE HIRING").
 */
const Eyebrow = ({ children, tone = "teal", className = "" }: Props) => (
  <div
    className={`font-mono text-[12.5px] tracking-[0.12em] ${
      tone === "lime" ? "text-primary-500" : "text-secondary-400"
    } ${className}`}
  >
    {children}
  </div>
);

export default Eyebrow;
